module.exports = __webpack_public_path__ + "static/media/coding.ba5061f9.svg";